<!-- EM_MO_SB_009  일반충전 -->
<template>
    <div class="stopusing-detail-wrap">
        <div class="order-text-box registration">
            <strong>카드명(별칭)을 입력해주세요</strong>
            <input ref="prepaidCardNickName" id='prepaidCardNickName' type="text" name="prepaidCardNickName" class="form-control" maxlength="10" v-model="cardData.prepaidCardNickName" placeholder="카드명(카드 식별용 별칭)" title="카드명(카드 식별용 별칭)"/>
        </div>
        <div class="order-text-box registration">
            <strong>이마티콘 번호 16자리 입력해주세요</strong>
            <input ref="prepaidCardNo" type="text" class="input-base" placeholder="16자리 입력" title="16자리 입력"
                 :value="cardData.prepaidCardNoView"
                 @input="emarticonNoBind"
                 @keyup="setDash($event)"
                 maxlength="19"
            />
        </div>
        <div class="order-text-box registration">
            <strong>PIN 번호 6자리를 입력해주세요</strong>
<!--            <common-number ref="pinNo" v-model.trim="cardData.pinNo" :options="{'maxlength':6}" placeholder="6자리 입력"/>-->
            <input ref="pinNo" type="text" class="input-base" placeholder="6자리 입력" title="6자리 입력"
                   :value="cardData.pinNo"
                   @input="pinNoBind"
                   oninput="this.value = this.value.replace(/[^0-9]/ig, '')"
                   maxlength="6"
            />
        </div>
        <gray-line class="mx-reset"></gray-line>
<!--        <terms-box class="pt-32"></terms-box>-->
        <div class="registration-agree-box pt-32">
          <div>
            <div class="flex-y-center radio-wrap">
              <label class="radiobox">
                <input type="checkbox" class="normal-radio icon-round-check" v-model="isTerms"/>
                <span>이마티콘 이용약관(필수)</span>
              </label>
            </div>
            <div class="terms-gray-box">
              <span>이마티콘 이용동의</span>
              <button @click="showAgreePopup = true">보기</button>
            </div>
          </div>
        </div>
        <gray-line class="mx-reset"></gray-line>
        <div class="registration-precautions mx-reset">
          <div>
            <span class="icon-tool-tip"></span>
            <strong>유의사항</strong>
          </div>
          <ul>
            <li>
              <p><span></span><em>MMS로 수신받은 이마티콘(선물 및 사은품)을 이마트앱에 등록하여 사용하실수 있습니다.</em></p>
            </li>
            <li>
              <p><span></span><em>등록된 이마티콘은 이마티콘의 이용약관에 의거하여 사용 및 환불이 가능합니다.</em></p>
            </li>
            <li>
              <p><span></span><em>이마트앱에 등록후에도 MMS로 수신받은 이마티콘도 동일하게 사용 가능합니다.</em></p>
            </li>
            <li>
              <p><span></span><em>이마티콘 번호 및 pin 번호는 수신하신 이마티콘 문자에 안내 되어 있습니다.</em></p>
            </li>
          </ul>
        </div>
        <div class="fixed">
            <div class="button-wrap">
                <button class="button-bg-yellow" @click="emarticonRegist()" :class="!isTerms ? 'button-disabled' : ''" :disabled="disabledChk()" >등록하기</button>
            </div>
        </div>
        <regist-popup v-if="cardRegistData.isView === true" :registData="cardRegistData" @closePopup="closePopup"/>
        <agree-popup v-if="showAgreePopup === true" @close="showAgreePopup = false" :terms="'termsOfUse'"></agree-popup>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import BgGrayText from '@/components/common/BgGrayText.vue';
import GrayLine from '@/components/common/GrayLine.vue';
import TermsBox from '@/components/common/TermsBox.vue';
import apiList from "@/api/apiList";
import cscript from '@/plugins/commonScripts'
import CommonNumber from '@/components/common/CommonNumber.vue'
import registPopup from '@/views/home/emarticonRegistrationPopup.vue'
import AgreePopup from "@/views/products/AgreePopup.vue";

export default {
    name: 'emarticonRegistration',
    components: {AgreePopup, BottomButton, BgGrayText, GrayLine, TermsBox, CommonNumber, registPopup },
    data() {
      return {
        cardData : {
          prepaidCardNickName : '',
          prepaidCardNoView : '',
          prepaidCardNo : '',
          pinNo : '',
          /*ctmmnyNo : 'C0000016',
          mberNo : 'C123456',
          requestId : 'C123456',*/
        },
        isTerms : '',
        cardRegistData: {
          isView: false,
          retMsg: '',
          retCode: ''
        },
        isRegistSuccess : '',
        showAgreePopup:false  //이용약관 보여줄지 여부
      }
    },
    mounted() {
      this.$heading('이마티콘 등록');
    },
    methods: {
      emarticonRegist () {
        this.cardData.prepaidCardNo = this.cardData.prepaidCardNoView.replaceAll('-','');
        let vaildCheck = this.isRegostValid();

        if(vaildCheck) {
          const params = this.cardData;

          apiList.putPrepaidActivation(params).then(res => {
            if(res.data !== null){
              if (res.data.code === "S00000") {
                this.cardRegistData.retMsg = '카드등록이 완료되었습니다.'
                this.cardRegistData.isView = true
                this.isRegistSuccess = true
              }else{
                this.cardRegistData.retMsg = res.message
                this.cardRegistData.isView = true
              }
            }else{
              this.cardRegistData.retMsg = res.message
              this.cardRegistData.isView = true
            }
          }).catch(err => {
            console.log(err)
            this.cardRegistData.retMsg = err.response.data.message
            this.cardRegistData.isView = true
          });
        }
      },

      isRegostValid(){
        console.log(this.isTerms)
        if (cscript.$isEmpty(this.cardData.prepaidCardNickName)) {
          alert('카드명(별칭)은 필수 항목입니다.')
          return false
        }
        if (cscript.$isEmpty(this.cardData.prepaidCardNoView)) {
          alert('이마티콘번호는 필수 항목입니다.')
          return false
        }
        if (this.cardData.prepaidCardNo.length < 16) {
          alert('이마티콘번호 16자리 입니다.')
          return false
        }
        if (cscript.$isEmpty(this.cardData.pinNo)) {
          alert('PIN번호는 필수 항목입니다.')
          return false
        }
        if (this.cardData.pinNo.length < 6) {
          alert('PIN번호는 6자리 입니다.')
          return false
        }
        if (!this.isTerms) {
          alert('이마티콘 이용약관은 필수 항목입니다.')
          return false
        }

        return true
      },

      disabledChk() {
        let flag = false;
        if (!this.isTerms) {
          flag = true;
        }
        return flag;
      },

      emarticonNoBind(e) {
        this.cardData.prepaidCardNoView = e.target.value;
      },

      pinNoBind(e){
        this.cardData.pinNo = e.target.value;
      },

      setDash(e){
        let inputNumber = e.target.value.replace(/[^0-9]/g, '');
        this.cardData.prepaidCardNoView = inputNumber.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-')
      },

      closePopup() {
        this.cardRegistData.isView = false
        if(this.isRegistSuccess) {
          this.$router.replace({name: 'saveBox'})
        }
      },
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/home/emarticonRegistration.scss';
</style>